import * as React from "react";
import { Form } from "antd";
import {
  QualifierFormConstants,
  SelectComponent
} from "../../../common/Constants";
import { FormComponentProps } from "antd/lib/form";
import { IAttribute } from "../../../model/formconfiguration/Attribute";
import SelectInput from "../../components/app/SelectInput";
import { IFormConfigQualifierAttribute } from "../../../service/formconfiguration/FormConfigQualifierAttribute";

export interface State {}

export interface AttributeSelectionFormProps extends FormComponentProps {
  translate: any;
  attributes?: IAttribute[];
  registerFormSubmitEventHandler?: any;
}

export default class AttributeSelectionForm extends React.Component<
  AttributeSelectionFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;

    registerFormSubmitEventHandler((e) => {
      e.preventDefault();
      let newFormConfigQualifierAttributeData = {} as IFormConfigQualifierAttribute;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newFormConfigQualifierAttributeData.attribute = {
            ...newFormConfigQualifierAttributeData.attribute,
            ...values
          };

          newFormConfigQualifierAttributeData = {
            ...newFormConfigQualifierAttributeData,
            ...values,
            attributeCode: values.code
          };
        }
      });
      return newFormConfigQualifierAttributeData;
    });
  }
  render() {
    const { translate, attributes } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <Form>
        <Form.Item label={translate("attribute_form.attribute")}>
          {getFieldDecorator(QualifierFormConstants.Fields.CODE, {
            rules: [
              {
                required: true,
                message: translate("attribute_form.required_message", {
                  field: translate("attribute_form.attribute")
                })
              }
            ]
          })(
            <SelectInput
              showSearch={true}
              placeholder={translate("attribute_form.select_qualifier")}
              style={{ width: SelectComponent.WIDTH }}
              allowClear
              notFoundContent={translate("search.no_data")}
              selectOptionKey={"code"}
              selectOptionValue={"attributeName"}
              selectOptions={attributes}
            />
          )}
        </Form.Item>
      </Form>
    );
  }
}
